function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { arraySubtract } from '../common/array-util';
import { CommunicationDisplayStatus } from '../models';
// 1) Status will default in the following conditions ON SAVE if the Status was not manually altered:
//   - If at least one subRequest is set to Waiting on Client, the Doc Request status is Waiting on Client.
//   - If no subRequests are Waiting on Client, and at least one subRequest is Received, the Doc Request is Received.
//   - If no subRequests are Waiting on Client or Received, and at least one subRequest is Completed, the Doc Request is Completed.
//   - If all subRequests are Canceled, the Doc Request is Canceled.

// 2) Manually changing the Doc Request Status will result in the following scenarios
//   - Waiting on Client
//     - If no subRequests are set to Waiting on Client, then upon clicking Save/Send, display an error message:
//       - "In order to change the status to Waiting on Client, you must also set at least one of the document requests to Waiting on Client."
//     - If at least one subRequest is already set to Waiting on Client, the Doc Request saves without error.
//   - Received
//     - Update any subRequests with a status of Waiting on Client to be Received and save.
//     - If there are no subRequests with a status of Waiting on Client and there is at least one with Received, save without error.
//     - If there are no subRequests with a status of either Waiting on Client or Received, display an error message:
//       - "In order to change the status to Received, you must also set at least one of the document requests to Received."
//   - Completed
//     - Update any subRequests with a status of Waiting on Client or Received to be Completed and save.
//   - Canceled
//     - Update any subRequests with a status of Waiting on Client or Received to be Canceled and save.
//     - There is no need to update the expiration date.

var WaitingOnClient = CommunicationDisplayStatus.WaitingOnClient;
var Received = CommunicationDisplayStatus.Received;
var Completed = CommunicationDisplayStatus.Completed;
var Canceled = CommunicationDisplayStatus.Canceled;

/* spell-checker: ignore Statused */

function beforeNow(date) {
  var now = new Date().getTime();
  return now > date.getTime();
}

/**
 * This very general interface works with both legacy (API) Requests and the new Communication model. When we're done with legacy it can be removed.
 */

function sameStatus(a, b) {
  return a.communicationStatus === b.communicationStatus;
}
function statusIs(communication, status) {
  return communication.communicationStatus === status;
}
function setStatus(communication, status) {
  return _objectSpread(_objectSpread({}, communication), {}, {
    communicationStatus: status
  });
}
function someHaveStatus(items, status) {
  return items.some(function (item) {
    return statusIs(item, status);
  });
}
function allHaveStatus(items, status) {
  return items.every(function (item) {
    return statusIs(item, status);
  });
}
export var ValidationError = /*#__PURE__*/function (ValidationError) {
  ValidationError["SubRequestWaitingOnClientRequired"] = "SubRequestWaitingOnClientRequired";
  ValidationError["SubRequestReceivedRequired"] = "SubRequestReceivedRequired";
  ValidationError["SubRequestNonCanceledRequired"] = "SubRequestNonCanceledRequired";
  ValidationError["SubRequestNonCompletedRequired"] = "SubRequestNonCompletedRequired";
  return ValidationError;
}({});
var CommunicationStatusService = /*#__PURE__*/function () {
  function CommunicationStatusService(communicationService, subRequestService) {
    _classCallCheck(this, CommunicationStatusService);
    this.communicationService = communicationService;
    this.subRequestService = subRequestService;
  }
  return _createClass(CommunicationStatusService, [{
    key: "updateCommunication",
    value: function () {
      var _updateCommunication = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(updated) {
        var current, groups;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.communicationService.get(updated.id, true);
            case 2:
              current = _context.sent;
              groups = this.groupSubRequestsForUpdate(current, updated); // First, add and update all subRequests with the same status as the updated request
              _context.next = 6;
              return Promise.all([this.addSubRequests(updated.id, groups.firstGroup.add), this.updateSubRequests(updated.id, groups.firstGroup.update)]);
            case 6:
              _context.next = 8;
              return Promise.all([this.addSubRequests(updated.id, groups.secondGroup.add), this.updateSubRequests(updated.id, groups.secondGroup.update), this.deleteSubRequests(updated.id, groups.secondGroup.delete)]);
            case 8:
              _context.next = 10;
              return this.updateRequest(updated);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateCommunication(_x) {
        return _updateCommunication.apply(this, arguments);
      }
      return updateCommunication;
    }()
  }, {
    key: "groupSubRequestsForUpdate",
    value: function groupSubRequestsForUpdate(previous, updated) {
      var groups = {
        firstGroup: {
          add: [],
          update: []
        },
        secondGroup: {
          add: [],
          update: [],
          delete: []
        }
      };

      /* eslint-disable no-lonely-if */
      updated.subRequests.forEach(function (subRequest) {
        var added = !previous.subRequests.find(function (sr) {
          return sr.id === subRequest.id;
        });
        if (sameStatus(subRequest, updated)) {
          if (added) {
            groups.firstGroup.add.push(subRequest);
          } else {
            groups.firstGroup.update.push(subRequest);
          }
        } else {
          if (added) {
            groups.secondGroup.add.push(subRequest);
          } else {
            groups.secondGroup.update.push(subRequest);
          }
        }
      });

      // All deleted go second
      groups.secondGroup.delete = arraySubtract(previous.subRequests, updated.subRequests);
      return groups;
    }
  }, {
    key: "validateStatuses",
    value: function validateStatuses(communication) {
      var hasWaitingOnClient = someHaveStatus(communication.subRequests, WaitingOnClient);
      if (statusIs(communication, WaitingOnClient) && !hasWaitingOnClient) {
        return ValidationError.SubRequestWaitingOnClientRequired;
      }
      var hasReceived = someHaveStatus(communication.subRequests, Received);
      if (statusIs(communication, Received) && !(hasReceived || hasWaitingOnClient)) {
        return ValidationError.SubRequestReceivedRequired;
      }
      var allCanceled = allHaveStatus(communication.subRequests, Canceled);
      if (statusIs(communication, Completed) && allCanceled) {
        return ValidationError.SubRequestNonCanceledRequired;
      }
      var allCompleted = allHaveStatus(communication.subRequests, Completed);
      if (statusIs(communication, Canceled) && allCompleted) {
        return ValidationError.SubRequestNonCompletedRequired;
      }
      return null;
    }
  }, {
    key: "isExpirationValid",
    value: function isExpirationValid(communication, expirationDate) {
      return statusIs(communication, Canceled) || !beforeNow(expirationDate);
    }

    /**
     * Changes request status as necessary based on subRequest status
     */
  }, {
    key: "propagateStatusUp",
    value: function propagateStatusUp(communication) {
      if (someHaveStatus(communication.subRequests, WaitingOnClient)) {
        return setStatus(communication, WaitingOnClient);
      }
      if (someHaveStatus(communication.subRequests, Received)) {
        return setStatus(communication, Received);
      }
      if (someHaveStatus(communication.subRequests, Completed)) {
        return setStatus(communication, Completed);
      }
      if (allHaveStatus(communication.subRequests, Canceled)) {
        return setStatus(communication, Canceled);
      }
      return communication;
    }
  }, {
    key: "cancelIfExpired",
    value: function cancelIfExpired(expiration, communication) {
      if (beforeNow(expiration) && statusIs(communication, WaitingOnClient)) {
        var canceled = setStatus(communication, Canceled);
        return this.propagateStatusDown(canceled);
      }
      return communication;
    }
  }, {
    key: "waitOnClientIfNotExpired",
    value: function waitOnClientIfNotExpired(expiration, communication) {
      if (!beforeNow(expiration) && statusIs(communication, Canceled)) {
        var waitingOnClient = setStatus(communication, WaitingOnClient);
        return this.updateSubRequestStatusIf(waitingOnClient, [Canceled], WaitingOnClient);
      }
      return communication;
    }

    /**
     * Changes subRequest status as necessary based on request status
     */
  }, {
    key: "propagateStatusDown",
    value: function propagateStatusDown(communication) {
      if (statusIs(communication, Received)) {
        // Set all WoC subRequests to Received
        return this.updateSubRequestStatusIf(communication, [WaitingOnClient], Received);
      }
      if (statusIs(communication, Completed)) {
        // Set all WoC and Received subRequests to Completed
        return this.updateSubRequestStatusIf(communication, [WaitingOnClient, Received], Completed);
      }
      if (statusIs(communication, Canceled)) {
        // Set all WoC and Received subRequests to Canceled
        return this.updateSubRequestStatusIf(communication, [WaitingOnClient, Received], Canceled);
      }
      return communication;
    }
  }, {
    key: "upgradeCommunicationStatus",
    value: function upgradeCommunicationStatus(oldStatus) {
      if (oldStatus === 'Sent') {
        return CommunicationDisplayStatus.Sent;
      }
      if (oldStatus === 'Closed' || oldStatus === 'PastDue' || oldStatus === 'Rejected') {
        return Completed;
      }
      return WaitingOnClient;
    }
  }, {
    key: "updateSubRequestStatusIf",
    value: function updateSubRequestStatusIf(communication, from, to) {
      return _objectSpread(_objectSpread({}, communication), {}, {
        subRequests: communication.subRequests.map(function (sr) {
          if (sr.communicationStatus && from.includes(sr.communicationStatus)) {
            return _objectSpread(_objectSpread({}, sr), {}, {
              communicationStatus: to
            });
          }
          return sr;
        })
      });
    }
  }, {
    key: "addSubRequests",
    value: function () {
      var _addSubRequests = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(requestId, added) {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Promise.all(added.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sr) {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", _this.subRequestService.createSubRequest(requestId, sr));
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x4) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function addSubRequests(_x2, _x3) {
        return _addSubRequests.apply(this, arguments);
      }
      return addSubRequests;
    }()
  }, {
    key: "updateSubRequests",
    value: function () {
      var _updateSubRequests = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(requestId, updated) {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return Promise.all(updated.map(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(sr) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", _this2.subRequestService.updateSubRequest(requestId, sr));
                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x7) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function updateSubRequests(_x5, _x6) {
        return _updateSubRequests.apply(this, arguments);
      }
      return updateSubRequests;
    }()
  }, {
    key: "deleteSubRequests",
    value: function () {
      var _deleteSubRequests = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(requestId, deleted) {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return Promise.all(deleted.map(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(sr) {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        return _context6.abrupt("return", _this3.subRequestService.deleteSubRequest(requestId, sr.id));
                      case 1:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x10) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function deleteSubRequests(_x8, _x9) {
        return _deleteSubRequests.apply(this, arguments);
      }
      return deleteSubRequests;
    }()
  }, {
    key: "updateRequest",
    value: function () {
      var _updateRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(request) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.communicationService.updateRequest(request);
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateRequest(_x11) {
        return _updateRequest.apply(this, arguments);
      }
      return updateRequest;
    }()
  }]);
}();
export { CommunicationStatusService as default };
